/**
 * from green to red, reversed the algorithm given here: https://gist.github.com/mlocati/7210513
 * @param perc
 * @returns
 */
export const perc2color = (perc: number) => {
  var r,
    g,
    b = 0
  if (perc < 50) {
    g = 255
    r = Math.round(5.1 * perc)
  } else {
    r = 255
    g = Math.round(510 - 5.1 * Math.min(perc, 100))
  }
  var h = r * 0x10000 + g * 0x100 + b * 0x1
  return '#' + ('000000' + h.toString(16)).slice(-6)
}

/**
 *
 * @param delta positive or negative delta percentage
 * @returns an hex gradient from red (bad) to green (good) according to the delta
 */
export const deltaPerc2Color = (delta: number) => {
  // let's consider delta from -50% to +50%
  // we want red for -50% and green for +50%
  // gradient in between

  let normalized = Math.min(Math.max(delta, -50), 50) // clamp to -50, 50
  normalized = -normalized + 50 // now it's 0 to 100, inverted!
  return perc2color(normalized)
}

/**
 * https://stackoverflow.com/a/16348977
 * @param str
 */
export const stringToColor = (str: string) => {
  let hash = 0
  str.split('').forEach((char) => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash)
  })
  let colour = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff
    colour += value.toString(16).padStart(2, '0')
  }
  return colour
}

/**
 *
 * https://stackoverflow.com/a/3943023
 * @param hex
 */
export const getContrastColor = (hex: string): 'black' | 'white' => {
  const r = parseInt(hex.substring(1, 3), 16)
  const g = parseInt(hex.substring(3, 5), 16)
  const b = parseInt(hex.substring(5, 7), 16)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 128 ? 'black' : 'white'
}
